exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "delegated-request-modal .delegated-request-modal .delegated-request-content{padding:25px 0}delegated-request-modal .delegated-request-modal .delegated-request-content .delegated-request-header{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;-moz-align-items:center;align-items:center;box-shadow:0 4px 4px 0 #eaebed}delegated-request-modal .delegated-request-modal .delegated-request-content .delegated-request-header .name,delegated-request-modal .delegated-request-modal .delegated-request-content .delegated-request-header avatar-app{width:100%;text-align:center}delegated-request-modal .delegated-request-modal .delegated-request-content .delegated-request-header .name{font-size:16px;color:#0072c9;padding-bottom:25px;margin-top:10px}delegated-request-modal .delegated-request-modal .delegated-request-content .delegated-request-body{margin:10px 10px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/food-benefit.module/components/delegatedRequestModal/delegatedRequestModal.scss
// module id = 1729
// module chunks = 0